'use client';

import dynamic from 'next/dynamic';

export const SargassMap = dynamic(
  () => import('./SargassMap').then((m) => m.SargassMap),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-[60vh] sm:h-[65vh] min-h-[420px] rounded-2xl border border-border bg-muted animate-pulse" />
    ),
  },
);
